import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'page-controls',
  templateUrl: './page-controls.component.html',
  styleUrls: ['./page-controls.component.scss']
})
export class PageControlsComponent {

  @Input() id: string | undefined;
  @Input() maxSize = 7;
  @Input() directionLinks = true;
  @Input() autoHide = true;
  @Input() previousLabel = 'Prev';
  @Input() nextLabel = 'Next';
  @Input() screenReaderPaginationLabel = 'Pagination';
  @Input() screenReaderPageLabel = 'page';
  @Input() screenReaderCurrentLabel = `You're on page`;

  @Output() pageChange = new EventEmitter<number>();

}
